import React from 'react';
import {
  getValueOrNotSpecifiedString,
  PatientDetailsHorizontalFlexElement,
  PatientDetailsPatientProp,
  PatientDetailsSection
} from './internal';
import { intl } from '../../lib';

/**
 * Props for a {@link PatientDetailsContactInformation} component.
 * @author agd
 */
export type PatientDetailsContactInformationProps = PatientDetailsPatientProp;

/**
 * Component for displaying a patient's contact information details.
 *
 * @param patient the patient whose data is displayed
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function PatientDetailsContactInformation({
  patient
}: PatientDetailsContactInformationProps): JSX.Element {
  // get the patient's mobile phone number if they have one
  const mobilePhone = patient.telecomAddresses?.find(addr => addr.type === 'CP')
    ?.value;
  return (
    <PatientDetailsSection
      className="ehs-patient-details-contact-information"
      title={intl('patientsearchportlet.view.createPatient.contact')}
    >
      <PatientDetailsHorizontalFlexElement
        label={intl('view.patient.mobile')}
        value={getValueOrNotSpecifiedString(mobilePhone) as string}
      />
      <PatientDetailsHorizontalFlexElement
        label={intl('view.patient.email')}
        value={getValueOrNotSpecifiedString(patient.email) as string}
      />
    </PatientDetailsSection>
  );
}
